import styled from 'styled-components'

export const Container = styled.li`
	position: relative;
	padding-bottom: 32px;
	margin: 0;
	list-style: none;

	&:last-of-type {
		padding-bottom: 0;
	}
`
